import { STOModel } from "src/models/base/sto-model";
import { AnomalyTypeDTO } from "src/models/tna/tna-anomalies/anomaly-type/anomaly-type-dto";
import { BaseApiService } from "../base/base-api.service";

export class AnomalyTypes extends BaseApiService<AnomalyTypeDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/Anomaly",
      loadItemsPath: "/GetAnomalyTypes",
    });
  }
}
